module.exports = __webpack_public_path__ + "img/UTKODA-10.baa43a50.jpg";